import styles from '../styles.scss';
import { IconMail, IconPhone } from 'components/Shared/Icon';
import { ContactNavigationBlock } from 'models/ContactNavigationBlock';
import { Icons } from 'models/Icons';
import { NavigationItem } from 'models/NavigationItem';
import connect from 'components/Shared/connect';
import { closeMainMenu } from 'components/MainMenu/actions';
import { Header, Item } from 'components/Navigation';

interface MergedProps extends ContactNavigationBlock {
  closeMainMenu: () => void;
}
export const ContactBlock = connect<MergedProps, ContactNavigationBlock>(undefined, dispatch => ({
  closeMainMenu: () => dispatch(closeMainMenu())
}))(({ header, items, closeMainMenu }: MergedProps) => (
  <Item className={styles.contact}>
    <Header className={styles.header} invert>
      {header}
    </Header>
    {items.map(item => (
      <Item key={item.title}>
        <Header className={styles.header}>
          <a href={item.url} onClick={closeMainMenu}>
            {'icon' in item && (item as NavigationItem).icon === Icons.Phone && <IconPhone />}
            {'icon' in item && (item as NavigationItem).icon === Icons.Email && <IconMail />}
            {item.title}
            {'subtitle' in item && <span>{(item as NavigationItem).subtitle}</span>}
          </a>
        </Header>
      </Item>
    ))}
  </Item>
));
